import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector, RootStateOrAny } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  ExportClientsActions,  
  PaginateClientsActions,
  PaginateClientsState,
} from "store/ducks/settings/clients";

import { SelectedFilterActions, SelectedFilterState } from "store/ducks/filter";

import * as S from "./styles";
import { MainContainer, Paginator, MenuSelector } from "components/shared";
import { GridClients, FilterClients } from "components/settings";
import { useTranslation, usePermissions } from "hooks";
import { translations } from "./translations";
import { useExportClientsXLSX } from "./ExportClients";

export const ListClients: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { getTranslation } = useTranslation(translations);
  const { checkUserPermission } = usePermissions();
  const { exportToXLSX } = useExportClientsXLSX();
  const [query, setQuery] = useState({
    limit: 10,
    page: 1,
  });
  const { data, loading, pagination } = useSelector<RootStateOrAny>(
    (state) => state.paginateClients
  ) as PaginateClientsState;

  const { loading: loadingExportData } = useSelector<RootStateOrAny>(
    (state) => state.exportClients
  ) as any;   

  const { data: dataFilter } = useSelector<RootStateOrAny>(
    (state) => state.selectedFilter
  ) as SelectedFilterState;

  const handleSubmitFilter = useCallback(
    (value) => {
      const data = {
        ...dataFilter,
        ...value,
        page: 1,
      };
      dispatch(SelectedFilterActions.success(data));
      setQuery((state) => ({ ...state, data }));
    },
    [setQuery, dispatch, dataFilter]
  );

  const handlePageChange = useCallback(
    (value) => {
      const data = {
        ...dataFilter,
        page: value,
      };
      dispatch(SelectedFilterActions.success(data));
      setQuery((state) => ({ ...state, data }));
    },
    [setQuery, dispatch, dataFilter]
  );

  const getData = useCallback(() => {
    dispatch(PaginateClientsActions.request({ ...query, ...dataFilter }));
  }, [dispatch, query, dataFilter]);

  const getDataClientExport = useCallback(() => {
    const queryExport = {
      limit: 99999,
      page: 1,
    }
    dispatch(
      ExportClientsActions.request(
      {
        query: { ...queryExport },
      },
      {
        onSuccess: (clientExportData: any) => {
          if (clientExportData?.length > 0) {
            exportToXLSX(clientExportData);
          } else {
            alert("Não há dados para exportar.");
          }
        },
      }
      )
    );
  }, [dispatch, exportToXLSX]);


  useEffect(() => {
    getData();
  }, [getData]);
  return (
    <MainContainer>
      <S.PageHeader>
        <h1>
          <S.IconSetting />
          {getTranslation("configuracoes")} <MenuSelector page="clients" />
          {loading && <S.LoadingPage />}
        </h1>
        <S.HeaderButtons>
          {checkUserPermission("insertClient") && (
            <S.ButtonMini onClick={() => getDataClientExport()}>
              {loadingExportData ? <S.LoadingPage /> : getTranslation("exportar")}
            </S.ButtonMini>
          )}  
          {checkUserPermission("insertClient") && (
            <S.ButtonMini style={{ marginRight: "24px" }} onClick={() => history.push("/settings/client/new")}>
              {getTranslation("novoCliente")}
            </S.ButtonMini>
          )}
          <FilterClients onFilter={handleSubmitFilter} />
        </S.HeaderButtons>
      </S.PageHeader>
      <S.PageContent>
        <GridClients clients={data} />
        <Paginator
          pagination={pagination}
          onPageChange={handlePageChange}
          loading={loading}
        />
      </S.PageContent>
    </MainContainer>
  );
};
